// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Js_math = require("bs-platform/lib/js/js_math.js");
var NumberHelper = require("./NumberHelper");
var Lang_eval$BwaxMobile = require("../../lang_eval.bs.js");
var Runtime_common$BwaxMobile = require("../runtime_common.bs.js");

function fail(name) {
  throw [
        Lang_eval$BwaxMobile.Eval_exn,
        "Number." + (name + ": Invalid Arguments")
      ];
}

function parse(prim) {
  return NumberHelper.parse(prim);
}

function format(prim, prim$1) {
  return NumberHelper.format(prim, prim$1);
}

function process_one_number(fname, handle_NaN, handle_inf, handle_neg_inf, handle_int, handle_float, args) {
  if (args) {
    var match = args[0][0];
    if (typeof match === "number" || !(match.tag === /* V_literal */5 && !args[1])) {
      return fail(fname);
    } else {
      var lit = match[0];
      var r;
      if (typeof lit === "number") {
        switch (lit) {
          case /* NaN */0 :
              r = Curry._1(handle_NaN, /* () */0);
              break;
          case /* Infinity */1 :
              r = Curry._1(handle_inf, /* () */0);
              break;
          case /* NegInfinity */2 :
              r = Curry._1(handle_neg_inf, /* () */0);
              break;
          
        }
      } else {
        switch (lit.tag | 0) {
          case /* Int */0 :
              r = Curry._1(handle_int, lit[0]);
              break;
          case /* Float */1 :
              r = Curry._1(handle_float, lit[0]);
              break;
          default:
            r = fail(fname);
        }
      }
      return /* tuple */[
              /* V_literal */Block.__(5, [r]),
              Runtime_common$BwaxMobile.nt
            ];
    }
  } else {
    return fail(fname);
  }
}

function one_number_handy(fname, handle_NaN, handle_inf, handle_neg_inf, handle_int, handle_float) {
  return /* tuple */[
          fname,
          Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                  return process_one_number(fname, handle_NaN, handle_inf, handle_neg_inf, handle_int, handle_float, param);
                }))
        ];
}

function only_positive_number(fname, proc) {
  return one_number_handy(fname, (function (param) {
                return /* NaN */0;
              }), (function (param) {
                return /* Infinity */1;
              }), (function (param) {
                return /* NaN */0;
              }), (function (i) {
                if (i >= 0) {
                  return /* Float */Block.__(1, [Curry._1(proc, i)]);
                } else {
                  return /* NaN */0;
                }
              }), (function (f) {
                if (f >= 0.0) {
                  return /* Float */Block.__(1, [Curry._1(proc, f)]);
                } else {
                  return /* NaN */0;
                }
              }));
}

function only_concrete_number(fname, proc) {
  return one_number_handy(fname, (function (param) {
                return /* NaN */0;
              }), (function (param) {
                return /* NaN */0;
              }), (function (param) {
                return /* NaN */0;
              }), (function (i) {
                return /* Float */Block.__(1, [Curry._1(proc, i)]);
              }), (function (f) {
                return /* Float */Block.__(1, [Curry._1(proc, f)]);
              }));
}

var externals_vals_000 = one_number_handy("isNaN", (function (param) {
        return /* Bool */Block.__(4, [true]);
      }), (function (param) {
        return /* Bool */Block.__(4, [false]);
      }), (function (param) {
        return /* Bool */Block.__(4, [false]);
      }), (function (i) {
        return /* Bool */Block.__(4, [false]);
      }), (function (f) {
        return /* Bool */Block.__(4, [false]);
      }));

var externals_vals_001 = /* :: */[
  one_number_handy("isInfinite", (function (param) {
          return /* Bool */Block.__(4, [false]);
        }), (function (param) {
          return /* Bool */Block.__(4, [true]);
        }), (function (param) {
          return /* Bool */Block.__(4, [true]);
        }), (function (_i) {
          return /* Bool */Block.__(4, [false]);
        }), (function (_f) {
          return /* Bool */Block.__(4, [false]);
        })),
  /* :: */[
    one_number_handy("toFloat", (function (param) {
            return /* NaN */0;
          }), (function (param) {
            return /* Infinity */1;
          }), (function (param) {
            return /* NegInfinity */2;
          }), (function (i) {
            return /* Float */Block.__(1, [i]);
          }), (function (f) {
            return /* Float */Block.__(1, [f]);
          })),
    /* :: */[
      one_number_handy("round", (function (param) {
              return /* NaN */0;
            }), (function (param) {
              return /* Infinity */1;
            }), (function (param) {
              return /* NegInfinity */2;
            }), (function (i) {
              return /* Int */Block.__(0, [i]);
            }), (function (f) {
              return /* Int */Block.__(0, [Math.round(f) | 0]);
            })),
      /* :: */[
        one_number_handy("floor", (function (param) {
                return /* NaN */0;
              }), (function (param) {
                return /* Infinity */1;
              }), (function (param) {
                return /* NegInfinity */2;
              }), (function (i) {
                return /* Int */Block.__(0, [i]);
              }), (function (f) {
                return /* Int */Block.__(0, [Js_math.floor(f)]);
              })),
        /* :: */[
          one_number_handy("ceiling", (function (param) {
                  return /* NaN */0;
                }), (function (param) {
                  return /* Infinity */1;
                }), (function (param) {
                  return /* NegInfinity */2;
                }), (function (i) {
                  return /* Int */Block.__(0, [i]);
                }), (function (f) {
                  return /* Int */Block.__(0, [Js_math.ceil(f)]);
                })),
          /* :: */[
            /* tuple */[
              "parse",
              Runtime_common$BwaxMobile.pack_func(1, (function (param) {
                      if (param) {
                        var match = param[0][0];
                        if (typeof match === "number" || match.tag !== /* V_literal */5) {
                          return fail("parse");
                        } else {
                          var match$1 = match[0];
                          if (typeof match$1 === "number" || !(match$1.tag === /* String */2 && !param[1])) {
                            return fail("parse");
                          } else {
                            var r = NumberHelper.parse(match$1[0]);
                            var lit = isNaN(r) ? /* NaN */0 : (
                                isFinite(r) ? /* Float */Block.__(1, [r]) : (
                                    r > 0 ? /* Infinity */1 : /* NegInfinity */2
                                  )
                              );
                            return /* tuple */[
                                    /* V_literal */Block.__(5, [lit]),
                                    Runtime_common$BwaxMobile.nt
                                  ];
                          }
                        }
                      } else {
                        return fail("parse");
                      }
                    }))
            ],
            /* :: */[
              /* tuple */[
                "format",
                Runtime_common$BwaxMobile.pack_func(2, (function (args) {
                        var match;
                        if (args) {
                          var match$1 = args[0][0];
                          if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                            match = fail("format");
                          } else {
                            var match$2 = args[1];
                            if (match$2) {
                              var match$3 = match$2[0][0];
                              match = typeof match$3 === "number" || !(match$3.tag === /* V_literal */5 && !match$2[1]) ? fail("format") : /* tuple */[
                                  match$1[0],
                                  match$3[0]
                                ];
                            } else {
                              match = fail("format");
                            }
                          }
                        } else {
                          match = fail("format");
                        }
                        var num = match[1];
                        var fmt = match[0];
                        var str;
                        var exit = 0;
                        if (typeof num === "number") {
                          switch (num) {
                            case /* NaN */0 :
                                str = "NaN";
                                break;
                            case /* Infinity */1 :
                                str = "Infinity";
                                break;
                            case /* NegInfinity */2 :
                                str = "-Infinity";
                                break;
                            
                          }
                        } else {
                          switch (num.tag | 0) {
                            case /* Int */0 :
                            case /* Float */1 :
                                exit = 1;
                                break;
                            default:
                              str = fail("format");
                          }
                        }
                        if (exit === 1) {
                          if (typeof fmt === "number" || fmt.tag !== /* String */2) {
                            str = fail("format");
                          } else {
                            var fmt$1 = fmt[0];
                            if (typeof num !== "number") {
                              str = NumberHelper.format(fmt$1, num[0]);
                            }
                            
                          }
                        }
                        return /* tuple */[
                                /* V_literal */Block.__(5, [/* String */Block.__(2, [str])]),
                                Runtime_common$BwaxMobile.nt
                              ];
                      }))
              ],
              /* :: */[
                only_positive_number("sqrt", (function (prim) {
                        return Math.sqrt(prim);
                      })),
                /* :: */[
                  /* tuple */[
                    "e",
                    /* tuple */[
                      /* V_literal */Block.__(5, [/* Float */Block.__(1, [Math.E])]),
                      Runtime_common$BwaxMobile.nt
                    ]
                  ],
                  /* :: */[
                    only_positive_number("log", (function (prim) {
                            return Math.log(prim);
                          })),
                    /* :: */[
                      only_positive_number("log2", (function (prim) {
                              return Math.log2(prim);
                            })),
                      /* :: */[
                        only_positive_number("log10", (function (prim) {
                                return Math.log10(prim);
                              })),
                        /* :: */[
                          /* tuple */[
                            "pi",
                            /* tuple */[
                              /* V_literal */Block.__(5, [/* Float */Block.__(1, [Math.PI])]),
                              Runtime_common$BwaxMobile.nt
                            ]
                          ],
                          /* :: */[
                            only_concrete_number("cos", (function (prim) {
                                    return Math.cos(prim);
                                  })),
                            /* :: */[
                              only_concrete_number("sin", (function (prim) {
                                      return Math.sin(prim);
                                    })),
                              /* :: */[
                                only_concrete_number("tan", (function (prim) {
                                        return Math.tan(prim);
                                      })),
                                /* :: */[
                                  only_concrete_number("acos", (function (prim) {
                                          return Math.acos(prim);
                                        })),
                                  /* :: */[
                                    only_concrete_number("asin", (function (prim) {
                                            return Math.asin(prim);
                                          })),
                                    /* :: */[
                                      one_number_handy("atan", (function (param) {
                                              return /* NaN */0;
                                            }), (function (param) {
                                              return /* Float */Block.__(1, [Math.PI / 2]);
                                            }), (function (param) {
                                              return /* Float */Block.__(1, [-(Math.PI / 2)]);
                                            }), (function (i) {
                                              return /* Float */Block.__(1, [Math.atan(i)]);
                                            }), (function (f) {
                                              return /* Float */Block.__(1, [Math.atan(f)]);
                                            })),
                                      /* :: */[
                                        /* tuple */[
                                          "atan2",
                                          Runtime_common$BwaxMobile.pack_func(2, (function (args) {
                                                  var match;
                                                  if (args) {
                                                    var match$1 = args[0][0];
                                                    if (typeof match$1 === "number" || match$1.tag !== /* V_literal */5) {
                                                      match = fail("atan2");
                                                    } else {
                                                      var match$2 = args[1];
                                                      if (match$2) {
                                                        var match$3 = match$2[0][0];
                                                        match = typeof match$3 === "number" || !(match$3.tag === /* V_literal */5 && !match$2[1]) ? fail("atan2") : /* tuple */[
                                                            match$1[0],
                                                            match$3[0]
                                                          ];
                                                      } else {
                                                        match = fail("atan2");
                                                      }
                                                    }
                                                  } else {
                                                    match = fail("atan2");
                                                  }
                                                  var x = match[1];
                                                  var y = match[0];
                                                  var r;
                                                  var exit = 0;
                                                  var exit$1 = 0;
                                                  var exit$2 = 0;
                                                  if (typeof y === "number") {
                                                    switch (y) {
                                                      case /* NaN */0 :
                                                          r = /* NaN */0;
                                                          break;
                                                      case /* Infinity */1 :
                                                          if (typeof x === "number") {
                                                            switch (x) {
                                                              case /* NaN */0 :
                                                                  exit$2 = 3;
                                                                  break;
                                                              case /* Infinity */1 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(1, 1)]);
                                                                  break;
                                                              case /* NegInfinity */2 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(1, -1)]);
                                                                  break;
                                                              
                                                            }
                                                          } else {
                                                            exit$1 = 2;
                                                          }
                                                          break;
                                                      case /* NegInfinity */2 :
                                                          if (typeof x === "number") {
                                                            switch (x) {
                                                              case /* NaN */0 :
                                                                  exit$2 = 3;
                                                                  break;
                                                              case /* Infinity */1 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(-1, 1)]);
                                                                  break;
                                                              case /* NegInfinity */2 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(-1, -1)]);
                                                                  break;
                                                              
                                                            }
                                                          } else {
                                                            exit$1 = 2;
                                                          }
                                                          break;
                                                      
                                                    }
                                                  } else {
                                                    switch (y.tag | 0) {
                                                      case /* Int */0 :
                                                          var yi = y[0];
                                                          if (typeof x === "number") {
                                                            switch (x) {
                                                              case /* NaN */0 :
                                                                  exit$2 = 3;
                                                                  break;
                                                              case /* Infinity */1 :
                                                              case /* NegInfinity */2 :
                                                                  exit = 1;
                                                                  break;
                                                              
                                                            }
                                                          } else {
                                                            switch (x.tag | 0) {
                                                              case /* Int */0 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(yi, x[0])]);
                                                                  break;
                                                              case /* Float */1 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(yi, x[0])]);
                                                                  break;
                                                              default:
                                                                r = fail("atan2");
                                                            }
                                                          }
                                                          break;
                                                      case /* Float */1 :
                                                          var yf = y[0];
                                                          if (typeof x === "number") {
                                                            switch (x) {
                                                              case /* NaN */0 :
                                                                  exit$2 = 3;
                                                                  break;
                                                              case /* Infinity */1 :
                                                              case /* NegInfinity */2 :
                                                                  exit = 1;
                                                                  break;
                                                              
                                                            }
                                                          } else {
                                                            switch (x.tag | 0) {
                                                              case /* Int */0 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(yf, x[0])]);
                                                                  break;
                                                              case /* Float */1 :
                                                                  r = /* Float */Block.__(1, [Math.atan2(yf, x[0])]);
                                                                  break;
                                                              default:
                                                                r = fail("atan2");
                                                            }
                                                          }
                                                          break;
                                                      default:
                                                        exit$2 = 3;
                                                    }
                                                  }
                                                  if (exit$2 === 3) {
                                                    if (typeof x === "number" && x === 0) {
                                                      r = /* NaN */0;
                                                    } else {
                                                      exit$1 = 2;
                                                    }
                                                  }
                                                  if (exit$1 === 2) {
                                                    if (typeof y === "number") {
                                                      r = y >= 2 ? /* Float */Block.__(1, [-(Math.PI / 2)]) : /* Float */Block.__(1, [Math.PI / 2]);
                                                    } else {
                                                      exit = 1;
                                                    }
                                                  }
                                                  if (exit === 1) {
                                                    r = typeof x === "number" ? (
                                                        x >= 2 ? /* Float */Block.__(1, [Math.PI]) : /* Float */Block.__(1, [0])
                                                      ) : fail("atan2");
                                                  }
                                                  return /* tuple */[
                                                          /* V_literal */Block.__(5, [r]),
                                                          Runtime_common$BwaxMobile.nt
                                                        ];
                                                }))
                                        ],
                                        /* [] */0
                                      ]
                                    ]
                                  ]
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var externals_vals = /* :: */[
  externals_vals_000,
  externals_vals_001
];

function externals(param) {
  return /* tuple */[
          "Number",
          externals_vals
        ];
}

var src = "\nmodule Number;\n\n-- Convert an integer into a float.\ntoFloat: Int -> Float = external;\n\n-- Round a number to the nearest integer.\nround: Float -> Int = external;\n\n-- Floor function, rounding down.\nfloor: Float -> Int = external;\n\n-- Ceiling function, rounding up.\nceiling: Float -> Int = external;\n\n\n-- Truncate a number, rounding towards zero.\ntruncate f: Float -> Int =\n  if f < 0 then\n    ceiling f\n  else \n    floor f\n;\n\n-- commonly used  \nisDigit c = Char.isDigit c\n;\n\nisEven x = x % 2 == 0;\n\n-- Format and parse function\n-- The logic is like http://numeraljs.com/\n\n-- See numerals document. \n-- It accepts a string, and return a Float, or NaN if the string doesn\'t represent a number.\n--   Number.parse \"10,000.12\" == 10000.12;\n--   Number.parse \"23rd\" == 23;\n--   Number.parse \"\$10,000.00\" == 10000;\n--   Number.parse \"100B\" == 100;\n--   Number.parse \"3.467TB\" == 3467000000000.0;\n--   Number.parse \"-76%\" == -0.76;\n--   Number.parse \"2:23:57\" == 0 / 0;  -- NaN\nparse: String -> Float = external;\n\n-- See numeral documents. \n--   Number.format \"0,0.0000\" 10000 == \"10,000.0000\";\n--   Number.format \"0,0\" 10000.23 == \"10,000\";\n--   Number.format \"+0,0\" 10000 == \"+10,000\";\n--   Number.format \"0,0.0\" -10000 == \"-10,000.0\";\n--   Number.format \"0.000\" 10000.1234 == \"10000.123\";\n--   Number.format \"00000\" 100.1234 == \"00100\";\n--   Number.format \"000.00\" 10 == \"010.00\";\n--   Number.format \"0[.]00000\" 10000.1234 == \"10000.12340\";\n--   Number.format \".00\" -0.23 == \"-.23\";\n--   Number.format \"(.00)\" -0.23 == \"(.23)\";\nformat: String -> number -> String = external;\n\n\n-- floating ponit checks\nisNaN: number -> Bool = external;\n\nisInfinite: number -> Bool = external;\n\n\n--- math functions\n\n-- Negate a number.\nnegate n: number -> number =\n  0 - n\n;\n\n-- Get the absolute value of a number.\nabs n: number -> number =\n  if n >= 0 then n else 0 - n\n;\n\n\n-- Perform modular arithmetic. \n-- The mod can only be positive number.\n-- This function is different from %. \n-- When n is positive, they are the same, but when n is negative, they is different.\n-- See https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf\nmodBy m n: Int -> Int -> Int = \n  let \n    mod = abs m \n  in \n    if n >= 0 then \n      n % mod \n    else \n      let \n        r = (negate n) % mod\n      in \n        if r == 0 then 0 else mod - r\n;\n\n-- Get the remainder after division. It is like %\n-- See https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf\nremainderBy m n: Int -> Int -> Int =\n  n % (abs m)\n;\n\n-- Clamps a number within a given range. \nclamp starting ending n: number -> number -> number -> number = \n  if n < starting then \n    starting\n  else if n >= ending then \n    ending \n  else \n    n\n;\n\n\n-- Take the square root of a number.\nsqrt: Float -> Float = external;\n\n\n-- An approximation of e.\ne: Float = external;\n\n\n-- Calculate the natural logarithm (base e) of a number.\nlog: Float -> Float = external;\n\n-- Calculate the base 2 logarithm of a number.\nlog2: Float -> Float = external;\n\n-- Calculate the base 10 logarithm of a number.\nlog10: Float -> Float = external;\n\n-- Calculate the logarithm of a number with a given base.\n--  logBase 10 100 == 2\n--  logBase 2 256 == 8\nlogBase base x: Float -> Float -> Float = \n  log(x) / log(base)\n;\n\n-- An approximation of pi.\npi: Float = external;\n\n-- Convert degrees to standard angles (radians).\n--  degrees 180 == 3.141592653589793\ndegrees d: Float -> Float = \n  pi * d / 180;\n\n-- Convert truns to standard angles (radians).\n--  turns (1/2) == 3.141592653589793\nturns t: Float -> Float = \n  pi * t * 2;\n;\n\n\n\n-- Figure out the cosine given an angle in radians.\ncos: Float -> Float = external;\n\n-- Figure out the sine given an angle in radians.\nsin: Float -> Float = external;\n\n-- Figure out the tangent given an angle in radians.\ntan: Float -> Float = external;\n\n-- Figure out the arccosine for adjacent / hypotenuse in radians:\nacos: Float -> Float = external;\n\n-- Figure out the arcsine for opposite / hypotenuse in radians:\nasin: Float -> Float = external;\n\n\n-- This helps you find the angle (in radians) to an (x,y) coordinate, but in a way that is rarely useful in programming.\natan: Float -> Float = external;\n\n-- This helps you find the angle (in radians) to an (x,y) coordinate. \n-- So rather than saying atan (y/x) you say atan2 y x and you can get a full range of angles.\natan2: Float -> Float -> Float = external;\n\n\n\n";

exports.src = src;
exports.fail = fail;
exports.parse = parse;
exports.format = format;
exports.process_one_number = process_one_number;
exports.one_number_handy = one_number_handy;
exports.only_positive_number = only_positive_number;
exports.only_concrete_number = only_concrete_number;
exports.externals_vals = externals_vals;
exports.externals = externals;
/* externals_vals Not a pure module */
